import React, { useState } from "react";
import { FileTextOutlined } from "@ant-design/icons";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import AgentDetailsModal from "../AgentDetailsModal/AgentDetailsModal";
import "./AgentDetailsTable.scss"
import { Skeleton } from "antd";

const AgentDetailsTable = ({ data, loading }) => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false); // ✅ define modal state
  const [selectedAgent, setSelectedAgent] = useState(null); // ✅ define selected agent state

  const handleViewClick = (record) => {
    setSelectedAgent(record);
    setModalOpen(true);
  };


const renderWithSkeleton = (text) =>
  loading ? <Skeleton.Input active size="small" style={{ width: 100 }} /> : (text || "N/A");


 const columns = [
  {
    title: "Customer Name",
    dataIndex: "customer_name",
    key: "customer_name",
    render: renderWithSkeleton,
  },
  {
    title: "Loan No.",
    dataIndex: "loan_no",
    key: "loan_no",
    render: renderWithSkeleton,
  },
  {
    title: "Bucket",
    dataIndex: "bucket",
    key: "bucket",
    render: (text) =>
      loading ? (
        <Skeleton.Input active size="small" style={{ width: 100 }} />
      ) : text ? (
        <span className="caseBucket">{text}</span>
      ) : (
        "N/A"
      ),
  },
  {
    title: "Amount Overdue",
    dataIndex: "amount_overdue",
    key: "amount_overdue",
    render: (text) =>
      loading ? (
        <Skeleton.Input active size="small" style={{ width: 100 }} />
      ) : (
        <span className="caseAmount">
          {Number.isFinite(Number(text)) && text !== null && text !== ""
            ? Number(text).toFixed(2)
            : "N/A"}
        </span>
      ),
  },
  {
    title: "Bank",
    dataIndex: "bank_name",
    key: "bank_name",
    render: renderWithSkeleton,
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: renderWithSkeleton,
  },
  {
    title: "Actions",
    key: "actions",
    align: "center",
    width: 120,
    render: (_, record) => (
      <button
        type="button"
        className="viewBtn"
        onClick={() => handleViewClick(record)}
      >
        <FileTextOutlined />
        Details
      </button>
    ),
  },
];


  // const data = Array.from({ length: 10 }, (_, i) => {
  //   const day = (i % 28) + 1; // day between 1-28
  //   return {
  //     key: i.toString(),
  //     customer_name: `Guy Hawkins ${i + 1}`,
  //     loan_no: "RARCRA200000038910",
  //     bucket: "3651",
  //     amount_overdue: `76994.0`, // ✅ dynamic date
  //     bank: `Reliance ARC`,
  //     product:"Student Loan",
  //     draRegNo: "0000002",
  //   };
  // });

  return (
    <div className="agent-detail-table">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(7).fill({}) : data?.results || []}
        pageSize={pageSize}
        setPageSize={setPageSize}
        /* `data` is the response object, so data.length was undefined and the
           pager read "0 items" no matter how many cases came back. */
        totalItems={loading ? 0 : data?.count ?? data?.results?.length ?? 0}
      />
      <AgentDetailsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        agent={selectedAgent}
      />
    </div>
  );
};

export default AgentDetailsTable;
